/* eslint-disable @typescript-eslint/no-explicit-any */
import { readFunctionMapping } from '../../../helper';
import {
    IFunctionGateway,
    IFunctionMapping,
    IFunctionMappingRest,
} from '../../../interfaces';
import { FetchService } from '@qrvey/fetch';
export class RestGatewayService implements IFunctionGateway {
    invoke(
        functionName: string,
        params: unknown,
        fnMapping: IFunctionMapping,
    ): Promise<any> {
        const restConfig = readFunctionMapping(
            functionName,
            fnMapping,
            params,
            'rest',
        ) as IFunctionMappingRest;

        const options = {
            ...restConfig.options,
            method: restConfig.method,
        };
        return FetchService.sendRequest(
            restConfig.endpoint,
            restConfig.body,
            options,
        );
    }
}
